import React from "react";
// import { useState } from "react";
// import AgencyRegistrationForm from "./AgencyRegistrationForm";
// import { GridStack } from "gridstack";
import GridItem from "../../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../../DMSHeader/DMSHeader";
import { useLocation } from 'react-router-dom';

// import ViewedExecuteSopsTable from "./ViewedExecuteSopsForm/ViewedExecuteSopsTable";


import { useTranslation } from 'react-i18next';
import ViewedExecuteSopsForm from "./ViewedExecuteSopsForm";


const ViewedSopInstance = (props) => {
  const { t, i18n } = useTranslation();

  const location = useLocation();
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader title={t('viewed_execute_sops_formheader')}  
//  showIconsForback={true}
  />
      ),
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 14,
      id: 2,
      //haveNoBg: true,
      component: <ViewedExecuteSopsForm  />,
    },

    // {
    //   x: 0,
    //   y: 2,
    //   width: 12,
    //   height: 7,
    //   id: 3,
    //   component: <ExecuteSopsTable  />,
    // },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 ">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default ViewedSopInstance;
